import { Flame, Skull, Crown } from "lucide-react";

const CHAPTER_MAP = {
  I: { title: "THE FALLEN GATE", floors: "1-2" },
  II: { title: "THE GATEKEEPER", floors: "3", boss: true },
  III: { title: "THE ASHEN LIBRARY", floors: "4-5" },
  IV: { title: "THE ARCHIVIST", floors: "6", boss: true },
  V: { title: "THE INFERNAL FORGE", floors: "7-9" },
  VI: { title: "THE EMBER KING", floors: "10", boss: true },
};

export default function ChapterBanner({ chapter, chapterTitle, floor, finalFloor = 10, isBossRoom }) {
  const meta = CHAPTER_MAP[chapter] || {};
  const displayTitle = chapterTitle || meta.title || "THE DESCENT";
  const pct = Math.min(100, Math.max(0, (floor / finalFloor) * 100));

  return (
    <div className="panel p-4" data-testid="chapter-banner">
      <div className="flex items-center gap-3">
        <div className="text-[10px] tracking-[0.4em] ash-text">CHAPTER</div>
        <div className="font-heading text-2xl gold-text leading-none" data-testid="chapter-roman">{chapter || "I"}</div>
        <div className="h-4 w-px bg-[#d4af37]/30" />
        <div className="font-heading text-lg text-[#f0e6d2] italic tracking-wide" data-testid="chapter-title">
          {displayTitle}
        </div>
        {isBossRoom && (
          <span className="ml-auto text-[10px] tracking-[0.3em] blood-text flex items-center gap-1" data-testid="boss-badge">
            <Skull size={12} /> BOSS
          </span>
        )}
      </div>
      <div className="mt-3 relative h-[6px] bg-black/60 border border-[#d4af37]/20 overflow-hidden">
        <div
          className="h-full transition-all duration-700"
          style={{ width: `${pct}%`, background: "linear-gradient(90deg, #8a0303, #e25822, #d4af37)" }}
        />
        {/* Boss floor markers */}
        {[2, 4, 6, 8, 10].map((bf) => (
          <div
            key={bf}
            className="absolute top-0 bottom-0 w-px bg-black"
            style={{ left: `${(bf / finalFloor) * 100}%` }}
            title={`Boss floor ${bf}`}
          />
        ))}
      </div>
      <div className="flex items-center justify-between text-[10px] tracking-[0.3em] ash-text mt-2">
        <span className="flex items-center gap-1"><Flame size={10} className="ember" /> FLOOR {floor}/{finalFloor}</span>
        <span className="flex items-center gap-1"><Crown size={10} className="gold-text" /> EMBER KING</span>
      </div>
    </div>
  );
}
